// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationNoteDto
 */
export interface IOrganizationNoteDto {
    /**
     * 
     * @type {string}
     * @memberof IOrganizationNoteDto
     */
    text?: string;
}

/**
 * Check if a given object implements the IOrganizationNoteDto interface.
 */
export function instanceOfIOrganizationNoteDto(value: object): value is IOrganizationNoteDto {
    return true;
}

export function IOrganizationNoteDtoFromJSON(json: any): IOrganizationNoteDto {
    return IOrganizationNoteDtoFromJSONTyped(json, false);
}

export function IOrganizationNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationNoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function IOrganizationNoteDtoToJSON(json: any): IOrganizationNoteDto {
    return IOrganizationNoteDtoToJSONTyped(json, false);
}

export function IOrganizationNoteDtoToJSONTyped(value?: IOrganizationNoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

